// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@routers/index' //页面路由对象
import promise from 'es6-promise'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import store from '@store/index' //数据存储状态
import filters from '@/filters/commonFilter' //过滤器
import regComp from '@/utils/regComp.js' //注册各个组件
import VueNavigation from 'vue-navigation' //导航布局组件
import './assets/css/theme_handler.scss'
import '@/assets/css/base.scss' //基础公共样式
import Handler from '@utils/handler'
import '@/assets/css/element-variables.scss' //基础公共样式
import storageAdapter from '@utils/storage/storage-adapter.js'
import '@/assets/icons/index.js'
import 'babel-polyfill'

promise.polyfill()
Vue.config.productionTip = false

Vue.use(VueNavigation, { router, store, keyName: 'ph' })
Vue.use(Handler.limit)
Vue.use(storageAdapter)
storageAdapter.init('1')

filters(Vue)
regComp(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js